export const FEATURE_FLAGS_RESOURCE = "v1/feature-flags";
export const FEATURE_FLAGS_ROUTE = "feature-flags";
export const FEATURE_FLAGS_LIST_PATH = "/settings/feature-flags";

export const FEATURE_FLAGS_TEXTS = {
  title: "Controle de Funcionalidades",
  subtitle:
    "Feature flags por ambiente em tempo real, sem necessidade de deploy.",
  filterTitle: "Filtrar",
  createTitle: "Incluir",
  successTitle: "Sucesso",
  successMessage: "Solicitação realizada com sucesso!",
};
